import React, { Component, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Features from "../../Components/Testimonials";
import styled from "@emotion/styled";

import Q1 from '../../img/T1.png'
import Q2 from '../../img/T2.png'
import Q3 from '../../img/T3.png'
const MainDiv = styled.div``;
const Span = styled.span`
  color: #ffffff;
  font-size: 44px;
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
`;
const P = styled.p`
  color: #ffffff;
  padding-top: 30px;
`;

const S7_RoadMap = () => {
  const q1 = [
    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. ",
  ];
  const q2 = [
    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. ",
  ];
  const q3 = [
    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. ",
  ];
  return (
    <MainDiv className="py-5" id="features">
      <Container>
        <Grid container item className="py-5 pl-lg-4">
          <Grid container direction="column" justify="center" xs={12}>
            <h1 className="fontweight text-center mb-5">
              <Span >
                <span style={{ borderBottom: "7px solid #B82E3C" }}>&nbsp;Testim</span>onials
              </Span>
            </h1>
          </Grid>
          <Features
            title="AHMED"
            des="CEO XYZ"
            cardIcon={Q1}
            content={q1}
          />
          <Features
            title="KINZA"
            des="CEO XYZ"
            cardIcon={Q2}
            content={q2}
          />
          <Features
            title="ASAD" 
            des="CEO XYZ" 
            cardIcon={Q3}
            content={q3}
          />
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S7_RoadMap;
